import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiCallLogReportService {

  constructor(private http: HttpClient) { }

  url = environment.serverAPI9 + "/api/apiCallLogReport";

  searchApiCallLogReport(query: string, page: number, size: number, sort: string, groupBy: any, additionalQuery: string): Observable<any> {
    let params: any = {
      page: page != null ? page : 0,
      size: size != null ? size : 12
    };

    if (sort != null && sort !== '') {
      params.sort = sort;
    }
    if (query != null && query !== '') {
      params.searchQuery = query.split("'").join('');
    }
    if (groupBy != null && groupBy !== '') {
      params.groupBy = groupBy;
    }
    if (additionalQuery != null && additionalQuery !== '') {
      params.additionalQuery = additionalQuery;
    }

    return this.http.get<any>(`${this.url}/condition`, { params });
  }

  downloadApiCallLogReport(): Observable<any> {
    return this.http.get(`${this.url}/export`, { responseType: 'arraybuffer', observe: 'response' });
  }

  getApiCallLogReport(Page: number, size: number, sort: string): Observable<any> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }
}
